<div bsModal #modificarPasswordModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true" [config]="{ backdrop: 'static',keyboard: false}">
    <div class="modal-dialog modal-primary" role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h4 class="modal-title">Preencha com a nova senha</h4>
                <button type="button" class="close" (click)="modificarPasswordModal.hide()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="alert alert-danger" *ngIf="errorsPassword.length > 0">
                    <h3 id="msgRetornoPassword">Opa! Alguma coisa não deu certo:</h3>
                    <ul>
                        <li *ngFor="let error of errorsPassword">{{ error }}</li>
                    </ul>
                </div>
                <form method="post" [formGroup]="passwordForm" enctype="multipart/form-data" class="form-horizontal">
                    <div class="form-group d-flex" [ngClass]="{'has-error': displayMessage.password }">
                        <label class="control-label mb-0 mr-2" for="password">Senha</label>
                        <div class="flex-fill">
                            <input class="form-control" id="password" type="password" formControlName="password" />
                        </div>
                    </div>

                    <div class="form-group d-flex" [ngClass]="{'has-error': displayMessage.password }">
                        <label class="control-label mb-0 mr-2" for="confirmPassword">Confirmar senha</label>
                        <div class="flex-fill">
                            <input class="form-control" id="confirmPassword" type="password"
                                formControlName="confirmPassword" />
                        </div>
                    </div>
                </form>
                <div class="my-4">
                    <button id="adicionarUsuario" type="botton" (click)="trocarPassword()"
                        class="btn btn-sm btn-primary">
                        <i class="fa fa-floppy-o fa-lg"></i> Salvar</button>
                </div>
            </div>
            <div class="modal-footer">
                <p><small>As senhas deverão ser iguais...</small></p>
            </div>
        </div>
    </div>
</div>
<div class="card">
    <div class="card-header">
        <strong>Gerenciamento de Usuários</strong>
    </div>
    <div class="card-body">
        <div>
            <div class="alert alert-danger" *ngIf="errors.length > 0">
                <h3 id="msgRetorno">Opa! Alguma coisa não deu certo:</h3>
                <ul>
                    <li *ngFor="let error of errors">{{ error }}</li>
                </ul>
            </div>

            <form method="post" [formGroup]="usuarioForm" enctype="multipart/form-data" class="form-horizontal">

                <div class="form-group d-flex" [ngClass]="{'has-error': displayMessage.nome }">
                    <label class="control-label mb-0 mr-2" for="nome">Nome</label>
                    <div class="flex-fill">
                        <input class="form-control" id="nome" type="text" formControlName="nome" />
                        <span class="text-danger" *ngIf="displayMessage.nome">
                            <p [innerHTML]="displayMessage.nome"></p>
                        </span>
                    </div>
                </div>

                <div class="form-group d-flex" [ngClass]="{'has-error': displayMessage.email }">
                    <label class="control-label mb-0 mr-2" for="email">E Mail</label>
                    <div class="flex-fill">
                        <input class="form-control" id="email" type="text" formControlName="email" />
                        <span class="text-danger" *ngIf="displayMessage.email">
                            <p [innerHTML]="displayMessage.email"></p>
                        </span>
                    </div>
                </div>

                <div *ngIf="!inEdition">

                    <div class="form-group d-flex" [ngClass]="{'has-error': displayMessage.password }">
                        <label class="control-label mb-0 mr-2" for="password">Senha</label>
                        <div class="flex-fill">
                            <input class="form-control" id="password" type="password" formControlName="password" />
                            <span class="text-danger" *ngIf="displayMessage.password">
                                <p [innerHTML]="displayMessage.password"></p>
                            </span>
                        </div>
                    </div>

                    <div class="form-group d-flex" [ngClass]="{'has-error': displayMessage.password }">
                        <label class="control-label mb-0 mr-2" for="confirmPassword">Confirmar senha</label>
                        <div class="flex-fill">
                            <input class="form-control" id="confirmPassword" type="password"
                                formControlName="confirmPassword" />
                            <span class="text-danger" *ngIf="displayMessage.confirmPassword">
                                <p [innerHTML]="displayMessage.confirmPassword"></p>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="form-group d-flex">
                    <label class="col-md-2 col-form-label">EtiquetasMarcopolo: </label>
                    <div class="col-md-10">
                        <input class="form-check-input mb-0 mr-2" type="checkbox" id="log" formControlName="etiquetasMarcopolo">
                    </div>
                </div> 

                <div class="form-group d-flex">
                    <label class="col-md-2 col-form-label">Log: </label>
                    <div class="col-md-10">
                        <input class="form-check-input mb-0 mr-2" type="checkbox" id="log" formControlName="log">
                    </div>
                </div> 
                
                <div class="form-group d-flex">
                    <label class="col-md-2 col-form-label">Ger. Usuarios:</label>
                    <div class="col-md-10">
                        <input class="form-check-input mb-0 mr-2" type="checkbox" id="Usuarios" formControlName="usuarios">
                    </div>
                </div>

            </form>

            <div class="my-4">
                <button id="Cancelar" type="botton" (click)="limparForm()" class="btn btn-sm btn-secondary">
                    <i class="fas fa-retweet"></i> Cancel</button>
                <button id="adicionarUsuario" type="botton" (click)="salvar()" class="btn btn-sm btn-primary">
                    <i class="fa fa-floppy-o fa-lg"></i> Salvar</button>
            </div>

        </div>
    </div>
</div>

<div class="card">
    <div class="card-header"><strong>Usuários Cadastrados</strong></div>
    <div class="card-body">
        <div style="overflow-x: auto">
            <table class="table table-bordered table-striped table-sm">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Login</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor='let usuario of usuarios'>
                        <td>{{ usuario.nome }}</td>
                        <td>{{ usuario.email }}</td>
                        <td>
                            <button id="editarUsuario" type="botton" (click)="colocarUsuarioEmEdicao(usuario)"
                                class="btn btn-sm btn-primary">
                                <i class="far fa-edit"></i> Editar</button>
                            <button id="redefinirSenha" type="botton" (click)="redefinirSenha(usuario)"
                                class="btn btn-sm btn-warning">
                                <i class="fas fa-key"></i> Redefinir Senha</button>
                            <button id="bloquearUsuario" type="botton" (click)="bloquearUsuario(usuario)"
                                class="btn btn-sm btn-secondary" *ngIf="!usuario.block">
                                <i class="fas fa-lock"></i> Bloquear</button>
                            <button id="desBloquearUsuario" type="botton" (click)="desBloquearUsuario(usuario)"
                                class="btn btn-sm btn-dark" *ngIf="usuario.block">
                                <i class="fas fa-lock-open"></i> Desbloquear</button>
                            <button id="editarUsuario" type="botton" (click)="excluirUsuario(usuario.id)"
                                class="btn btn-sm btn-danger">
                                <i class="fas fa-trash"></i> Excluir</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>